export const SET_MODELS = 'setModels';
export const SET_FLOORS = 'setFloors';
export const SET_NAMES = 'setNames';
export const SET_UNITS = 'setUnits';
export const SET_KIOSK = 'setKiosk';
export const SET_PORTALS = 'setPortals';
export const SET_JSON_CONFIG_DATA = 'setJsonConfigData';

export const REMOVE_PATH = 'removePath';
export const REBUILD_PATH = 'rebuildPath';
export const MAP_SHOW_FLOOR = 'showFloor';
export const MAP_SHOW_OBJECT = 'showObject';
export const MAP_SHOW_PATH = 'map:showPath';
export const SET_NORMALIZED_ZOOM = 'normalized_zoom';
export const SET_GYROSCOPE_STATE = 'set_gyroscope_state';
export const RESET_MAP_VIEW = 'RESET_MAP_VIEW';
export const MAP_HIGHLIGHT_UNITS = 'map:highlightUnits';
export const START_GUIDE_OVERVIEW = 'startGuideOverview';
export const GET_UNIT_DISTANCES = 'map:getUnitDistances';
export const REQUEST_CAMERA_ORIENTATION = 'requestCameraOrientation';
export const RESPONSE_CAMERA_ORIENTATION = 'responseCameraOrientation';
export const TURN_ON_DEVICE_ORIENTATION_EVENTS = 'turnOnDeviceOrientationEvents';
export const DISABLE_TOUCH_HORIZONTAL_ROTATION = 'disableTouchHorizontalRotation';
